import { createElement, ReactElement } from 'react'
import { ICellRendererParams } from 'ag-grid-community'

export const renderEditableValue = <T,>(params: ICellRendererParams<T>): ReactElement | string => {
  const displayValue = params.valueFormatted ?? params.value ?? ''

  if (params.node?.group || params.node?.rowPinned || params.context?.isUSDSelected) {
    return displayValue
  }

  return createElement('span', { className: 'editable-value-pill' }, displayValue)
}
